var _defs, _g, _g2, _g3, _g4, _path, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "300 270 400 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471 277.27h21V307h-21Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471 277.27h21v30h-21Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501 277.27h20V307h-20Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 277.27h21v30h-21Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.21 291H449v3H304.21Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M491.23 287.22v9.85c0 2.68-1.09 5.1-2.84 6.85a9.64 9.64 0 0 1-6.85 2.84v-9.85a9.69 9.69 0 1 1 9.69-9.69m0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M481.54 307.02h-.26v-9.85a9.96 9.96 0 0 1-9.69-9.95c0-5.4 4.46-9.95 9.95-9.95a9.96 9.96 0 0 1 9.95 9.95v9.85a9.9 9.9 0 0 1-2.91 7.04 9.9 9.9 0 0 1-7.04 2.91m0-29.22a9.43 9.43 0 0 0 0 18.85h.26v9.85a9.36 9.36 0 0 0 6.4-2.76 9.38 9.38 0 0 0 2.76-6.67v-9.85c0-5.2-4.22-9.42-9.42-9.42m0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M520.57 287.22v9.85c0 2.68-1.09 5.1-2.84 6.85a9.64 9.64 0 0 1-6.85 2.84v-9.85a9.69 9.69 0 1 1 9.69-9.69m0 0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M510.88 307.02h-.26v-9.85a9.96 9.96 0 0 1-9.69-9.95c0-5.4 4.46-9.95 9.95-9.95a9.96 9.96 0 0 1 9.95 9.95v9.85a9.9 9.9 0 0 1-2.91 7.04 9.9 9.9 0 0 1-7.04 2.91m0-29.22a9.43 9.43 0 0 0 0 18.85h.26v9.85a9.36 9.36 0 0 0 6.4-2.76 9.38 9.38 0 0 0 2.76-6.67v-9.85c0-5.2-4.22-9.42-9.42-9.42m0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M543.54 291.1h144.02v2.1H543.54Zm0 0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#225378",
    d: "M304.86 291.1H448.9v2.1H304.86Zm0 0"
  }))));
};
export default SvgQuote;